import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';
import StickersIcon from '../../../../../icons/StickersIcon';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerCardElementSticker = ({ className, onClick }) => {
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-sticker': true,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      <CardDesignerCardElementPlaceholder icon={<StickersIcon />} />
    </a>
  );
};

CardDesignerCardElementSticker.propTypes = propTypes;

export default CardDesignerCardElementSticker;
